import { createAction, props } from '@ngrx/store';

import { DocumentBuilderData } from '@lockton-apps/shared/ui/presentation-builder';

export enum ProposalDocumentBuilderActionTypes {
  Init = '[ProposalDocumentBuilder Page] Initialised',
  DocumentSaved = '[ProposalDocumentBuilder Page] Document Saved',
}

export const ProposalDocumentBuilderActions = {
  init: createAction(ProposalDocumentBuilderActionTypes.Init),
  documentSaved: createAction(
    ProposalDocumentBuilderActionTypes.DocumentSaved,
    props<{ data: DocumentBuilderData }>()
  ),
};
